/** @format */

import { useState, useEffect } from 'react';
import { searchLeadsApiService } from 'services/apiService';
// import type { PropertiesData, PaginationData } from "@types";

// type FmSearchPropertiesResponse =
//   | {
//       data: {
//         status: string;
//         message: string;
//         data?: {
//           properties: Array<PropertiesData>;
//         } & PaginationData;
//       };
//     }
//   | undefined;

export const useLeadsSearch = ({ page = 1 }) => {
  const [leads, setleads] = useState([]);
  const [paging, setPaging] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return; // run only on client

    const fetchLeads = async () => {
      try {
        setLoading(true);
        const response = await searchLeadsApiService({
          page,
          source: 'fm_renovation'
        });
        setleads(response?.data?.data || []);
        setPaging(response?.data?.paging || {});
      } catch (err) {
        setError(err.message || 'Failed to fetch leads');
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, [page]);

  return { leads, loading, error, paging };
};
